
import { defineComponent } from 'vue'
import { mapState, mapMutations } from 'vuex'

export default defineComponent({
    name: 'BaseComponent',
    data () {
        return {
            isPlaying: false
        }
    },
    computed: {
        ...mapState(['musicPaused', 'activityData'])
    },
    watch: {
        musicPaused (val) {
            const audioDom = this.$refs.audio as HTMLAudioElement
            if (!audioDom) {
                return
            }
            if (val) {
                audioDom.pause()     
            } else {
                audioDom.play()
            }
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.firstPaly()
        })
    },
    methods: {
        ...mapMutations(['SET_MUSICPAUSED']),
        firstPaly (): void {
            const audioDom = this.$refs.audio as HTMLAudioElement
            if (!audioDom) {
                return
            }
            if (!this.musicPaused) {
                audioDom.play()
            }
            // 微信自动播放
            document.addEventListener("WeixinJSBridgeReady", () => {
                audioDom.play()
            }, false)
            // 兼容其他不自动播放的情况
            document.addEventListener("touchstart", () => {
                if (!this.musicPaused) {
                    audioDom.play()
                }
            }, false)
        },
        switchMusic (): void {
            this.SET_MUSICPAUSED(!this.musicPaused)
        },
        play (): void {
            this.isPlaying = true
        },
        pause (): void {
            this.isPlaying = false
        }
    }
})
